

export default {
   goldOrders: [],
   totalGoldOrders: [],
}
